export interface InfoEmailModel {
  message: string;
  emailAddress: string;
}

export const getEmptyInfoEmailModel = (): InfoEmailModel => {
  return {
    message: "",
    emailAddress: ""
  }
}


// WEBPACK FOOTER //
// ./src/common/models/InfoEmailModels.ts